import TitleBlock from '@anm/components/TitleBlock';
import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter, flexRow, media } from '@anm/styles/helpers';
import slick from '@anm/styles/third-party/slick';
import styled, { css } from 'styled-components';

import { ArrowProps, CarouselWrapperProps } from './types';

const sectionTitleOnMobile = media.phone`
  font-size: 26px;
  line-height: 35px;
`;

export const SectionTitle = styled(TitleBlock)`
  width: unset;
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    line-height: 48px;
    ${sectionTitleOnMobile}
  }
`;

export const SliderHeader = styled.div`
  ${flexRow};
  ${flexCenter};
  margin-bottom: 25px;
  justify-content: space-between;
  button {
    padding: 0;
    font-size: 16px;
    min-width: 113px;
  }
`;

export const LoaderWrapper = styled.div`
  ${flexCenter};
  min-height: 335px;
`;

export const SlideWrapper = styled.div`
  width: 280px;
  margin-right: 40px;
  img {
    background: url(${getFromCdn('images/dashboard/default_preview.svg')})
      center center no-repeat rgb(235, 238, 245);
  }
  & > div {
    overflow: hidden;
    border-radius: 10px;
    border: 1px solid rgba(1, 83, 130, 0.2);
  }
  h2,
  h3,
  h4 {
    min-height: 40px;
  }
`;

const leftArrowOnMobile = media.phone`
  left: 5px;
`;

const rightArrowOnMobile = media.phone`
  right: 5px;
`;

const getArrowDirectionStyles = ({
  direction,
  hideLeft,
  hideRight
}: ArrowProps) =>
  ({
    left: css`
      left: 20px;
      transform: rotate(180deg);
      opacity: ${hideLeft ? 0 : 1};
      ${leftArrowOnMobile};
    `,
    right: css`
      right: 20px;
      opacity: ${hideRight ? 0 : 1};
      ${rightArrowOnMobile};
    `
  }[direction]);

const arrowSrc = getFromCdn('images/video-templates/slider-arrow.svg');

export const SliderArrowWrapper = styled.button<ArrowProps>`
  top: 52%;
  z-index: 1;
  width: 34px;
  height: 34px;
  border: none;
  outline: none;
  cursor: pointer;
  position: absolute;
  background: url('${arrowSrc}') no-repeat center / contain;

  ${getArrowDirectionStyles}
`;

const carouselWrapperOnMobile = media.phone`
  padding: 0 30px;
`;

export const CarouselWrapper = styled.div<CarouselWrapperProps>`
  padding: 0 63px;
  max-width: 100vw;
  margin-bottom: 57px;
  position: relative;

  ${slick};

  div {
    outline: none;
  }

  .slick-slide {
    margin-right: 40px;
    min-width: ${({ width }) => width}px;
  }

  .slick-slider {
    margin: 0 auto;
    position: static;
  }
  .slick-dots {
    display: none !important;
  }

  .slick-track {
    display: flex;
    width: 100% !important;
  }
  ${carouselWrapperOnMobile};
`;
